import { Directive } from '@angular/core';
import { BrnAccordionContent } from '@spartan-ng/brain/accordion';
import { classes } from '@spartan-ng/helm/utils';

/**
 * The brain directive only reports state — it sets `data-state`, `inert` and the
 * measured `--brn-accordion-content-height`, but never hides anything. Collapsing
 * is entirely this layer's job, which is why the height is driven here.
 *
 * Note this cannot use tw-animate-css's `animate-accordion-up/down`: those
 * keyframes read `--radix-…`/`--bits-…`/`--reka-…`/`--kb-…`/`--ngp-accordion-content-height`
 * and know nothing about spartan's `--brn-` prefix, so they would animate to
 * `auto` and, with no fill mode, snap back open when the animation ends.
 *
 * Padding belongs on the consumer's inner wrapper: it would otherwise be part of
 * the measured height and make the collapsed state keep a visible gap.
 */
@Directive({
  selector: 'hlm-accordion-content,[hlmAccordionContent]',
  hostDirectives: [{ directive: BrnAccordionContent, inputs: ['style'] }],
  host: { 'data-slot': 'accordion-content' },
})
export class HlmAccordionContent {
  constructor() {
    classes(
      () =>
        'block overflow-hidden text-sm transition-[height] duration-200 ease-out h-(--brn-accordion-content-height) data-[state=closed]:h-0',
    );
  }
}
